import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getCategories,
  addCategory as addLang,
  updateCategory as updateLang,
  deleteCategory as deleteLang,
  updateCategoryStatus as updateLangStatus,
} from "../../services/categoryService";
import { toast } from "react-toastify";

const initialState = {
  categories: [],
  status: "idle", // "idle" | "loading" | "succeeded" | "failed"
  error: null,
};

// Fetch all categories
export const fetchCategories = createAsyncThunk(
  "categories/fetchCategories",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getCategories();
      return response;
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
      return rejectWithValue(error.response?.data?.message || "An error occurred");
    }
  }
);

// Add a new category
export const addCategory = createAsyncThunk(
  "categories/addCategory",
  async (category, { rejectWithValue }) => {
    try {
      const response = await addLang(category);
      toast.success(response.message || "Data added successfully!");
      return response;
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
      return rejectWithValue(error.response?.data?.message || "An error occurred");
    }
  }
);



// Update a category
export const updateCategory = createAsyncThunk(
  "categories/updateCategory",
  async ({ id, category }, { rejectWithValue }) => {
    try {
      const response = await updateLang(id, category);
      toast.success(response.message || "Data updated successfully!");
      return response;
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
      return rejectWithValue(error.response?.data?.message || "An error occurred");
    }
  }
);

// Update a category status
export const updateCategoryStatus = createAsyncThunk(
  "categories/updateCategoryStatus",
  async ({ id, statusObj }, { rejectWithValue }) => {
    try {
      const response = await updateLangStatus(id, statusObj);
      toast.success(response.message || "Status updated successfully!");
      return { id, statusObj };
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
      return rejectWithValue(error.response?.data?.message || "An error occurred");
    }
  }
);

// Delete a category
export const deleteCategory = createAsyncThunk(
  "categories/deleteCategory",
  async (id, { rejectWithValue }) => {
    try {
      let response = await deleteLang(id);
     toast.success(response.message || "Data deleted successfully!");
      return id;
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
      return rejectWithValue(error.response?.data?.message || "An error occurred");
    }
  }
);

const categorySlice = createSlice({
  name: "categories",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Categories
      .addCase(fetchCategories.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchCategories.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.categories = action.payload.data;
      })
      .addCase(fetchCategories.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

       // Update Category Status
       .addCase(updateCategoryStatus.fulfilled, (state, action) => {
        const {id,statusObj} = action.payload;

        // Ensure `state.languages` exists and is an array
        if (!Array.isArray(state.categories)) {
            return;
        }
        const index = state.categories.findIndex((category) =>{
         return category._id === id
        });
        if (index !== -1) {
          state.categories[index] = { ...state.categories[index], ...statusObj };
        }
      })

        // Add Category
            .addCase(addCategory.fulfilled, (state, action) => {
              state.categories.unshift(action.payload.data); // Add at the beginning
            })
      
            // Update Category
            .addCase(updateCategory.fulfilled, (state, action) => {
              const updatedCategory = action.payload.data;
      
              if (!Array.isArray(state.categories)) {
                  return;
              }
              const index = state.categories.findIndex((category) =>{
               return category._id === updatedCategory._id
              });
              if (index !== -1) {
                state.categories[index] = { ...state.categories[index], ...updatedCategory };
              }
            })


       // Delete Language
       .addCase(deleteCategory.fulfilled, (state, action) => {
        const deletedId = action.payload;
        state.categories = state.categories.filter((astro) => astro._id !== deletedId);
      });
     
  },
});

export const { clearError } = categorySlice.actions;
export default categorySlice.reducer;
